<template>
  <div>

    <body data-anchor="pagetop" class="home page-template-default page page-id-314 wp-embed-responsive st-Grid_Container" style="overflow-y: unset;">
      <navbar follow="st-Header" imgSrc="../../../../static/img/logo/logo-black.png"></navbar>
      <div class="st-FixedPoint"></div>
      <div class="st-MainContainer">
        <main class="st-MainContents" style="padding-top: 120px;">

          <header class="series-PageTitle">
            <div class="series-PageTitle_Inner" data-appear>
              <h1>
                <span class="series-PageTitle_Logo" style="width: 80%;">CONTACT US</span>
                <span class="series-PageTitle_Title" style="color:#FFF">お問い合わせ</span>
              </h1>
              <div class="sw-parallax">
                <div class="sw-parallax_outer js-parallax_outer">
                  <div class="sw-parallax_inner">
                    <div class="sw-parallax_block js-parallax_block">
                      <div class="sw-parallax_target promotion-PageTitle-visual" style="background: url(../../../../static/img/contact/CONTACT.jpg) 50%/cover no-repeat;top: 70px;height: 480px;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </header>

          <section class="company-Profile">
            <div class="company-Profile_Inner st-Grid_Inner_appear">
              <div class="st-Grid_Inner p-0 contact-index-appear-1" data-appear="true">
                <h2 class="common-text-appear text-center contact-index-appear-2" data-appear="true">
                  <span class="sw-Section_Header-en pb-3">
                    <b>
                      <font>
                        <font>お問い合わせ</font>
                      </font>
                    </b>
                  </span>
                </h2>
              </div>
              <div class="col-12 p-xl-0 mb-5 mt-8 p-0 common-appear contact-index-appear-3" data-appear="true">

                <el-form :model="connectForm" :rules="rules" :label-position="'right'" ref="connectForm" id="connect-form">
                  <div class="form-content">

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>名前</label>
                        </div>
                        <div class="row m-0 col-12 col-md-7">
                          <el-form-item class="col-6 pl-0" prop="名前1">
                            <el-input v-model="connectForm['名前1']"></el-input>
                          </el-form-item>
                          <el-form-item class="col-6 pr-0" prop="名前2">
                            <el-input v-model="connectForm['名前2']"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>ふりがな</label>
                        </div>
                        <div class="row m-0 col-12 col-md-7">
                          <el-form-item class="col-6 pl-0" prop="ふりがな1">
                            <el-input v-model="connectForm['ふりがな1']"></el-input>
                          </el-form-item>
                          <el-form-item class="col-6 pr-0" prop="ふりがな2">
                            <el-input v-model="connectForm['ふりがな2']"></el-input>
                          </el-form-item>
                        </div>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>メールアドレス</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="メールアドレス">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input v-model="connectForm['メールアドレス']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>電話番号</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="電話番号">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input v-model="connectForm['電話番号']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="optional">任意</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>会社名</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="会社名">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input v-model="connectForm['会社名']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="optional">任意</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>部署名</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="部署名">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input v-model="connectForm['部署名']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="optional">任意</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>役職</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="役職">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input v-model="connectForm['役職']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 text-left text-md-right">
                          <label>お問い合わせの内容</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="お問い合わせの内容">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <el-input type="textarea" :autosize="{ minRows: 8}" v-model="connectForm['お問い合わせの内容']"></el-input>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="item">
                      <div class="row col-12 col-md-11 mx-0 p-0 mt-5">
                        <div class="col-3 col-md-1 pl-md-0 pr-0 text-md-right">
                          <span class="required">必須</span>
                        </div>
                        <div class="col-8 col-md-3 pl-0 pr-0 text-left text-md-right">
                          <label class="show-pc">個人情報の取扱いについて</label>
                          <label class="show-sp" style="font-size:12px">個人情報の取扱いについて</label>
                        </div>
                        <el-form-item class="col-12 col-md-7" prop="個人情報の取扱いについて">
                          <div class="row m-0">
                            <div class="col-12 pl-0 pr-0">
                              <div class="show-pc">
                                個人情報の取り扱いについては
                                <router-link to="/privacy" target="_blank" class="link_pink">こちら</router-link>
                              </div>
                              <div class="show-sp" style="font-size:12px">
                                個人情報の取り扱いについては
                                <router-link to="/privacy" target="_blank" class="link_pink">こちら</router-link>
                              </div>
                              <el-radio-group v-model="connectForm['個人情報の取扱いについて']">
                                <el-radio label="個人情報の取扱いに同意する"></el-radio>
                              </el-radio-group>
                            </div>
                          </div>
                        </el-form-item>
                      </div>
                    </div>

                  </div>

                  <p id="form_submit"><input type="button" @click="submitEmailForm('connectForm')" value="入力内容を確認する"></p>
                </el-form>

                <div class="box_inexp common-text-appear contact-index-appear-4" data-appear="true">
                  <h3 class="py-3">お問い合わせ先</h3>
                  <div class="box_inex_body">
                    <p class="p-md-0 p-3">
                      〒１０５―００２２　東京都港区海岸1丁目2番20号<br />
                      汐留ビルディング3階<br />
                      総務部　　info@roboticsolutions.co.jp<br /></p>
                  </div>
                </div>
              </div>
            </div>
          </section>

        </main>
        <div class="st-Breadcrumbs">
          <ul class="st-BreadcrumbsList" itemscope="itemscope" itemtype="">
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <router-link class="st-BreadcrumbsList_Item-link" to="/" itemprop="item">ホーム</router-link>
              <meta itemprop="position" content="1">
            </li>
            <li class="st-BreadcrumbsList_Item" itemprop="itemListElement" itemscope="itemscope" itemtype="">
              <p itemprop="item" aria-current="page" style="margin-bottom: 0rem;"><span itemprop="name">お問い合わせ</span></p>
              <meta itemprop="position" content="3">
            </li>
          </ul>
        </div>
      </div>
      <copyright></copyright>
    </body>
  </div>
</template>
<style />
<script type="text/javascript">
import copyright from './../copyright'
import navbar from './../navbar'
import { Loading } from 'element-ui';

export default {
  components: { copyright, navbar },
  data: function () {
    let validateEmail = (rule, value, callback) => {
      if (value != this.connectForm["メールアドレス"]) {
        callback(new Error('メールアドレスが一致しません'))
      } else {
        callback()
      }
    }

    let validateName = (rule, value, callback) => {
      if (!this.connectForm["名前1"] || !this.connectForm["名前2"]) {
        callback(new Error('名前が入力されていません'))
      } else if (this.connectForm["名前1"].length + this.connectForm["名前2"].length > 128) {
        callback(new Error('Please enter no more than 128 characters.'))
      } else {
        callback()
      }
    }

    let validateFurigana = (rule, value, callback) => {
      if (!this.connectForm["ふりがな1"] || !this.connectForm["ふりがな2"]) {
        callback(new Error('ふりがなが入力されていません'))
      } else if (this.connectForm["ふりがな1"].length + this.connectForm["ふりがな2"].length > 128) {
        callback(new Error('Please enter no more than 128 characters.'))
      } else {
        callback()
      }
    }

    return {
      connectForm: {
        "名前1": '',
        "名前2": '',
        "ふりがな1": '',
        "ふりがな2": '',
        "メールアドレス": '',
        "電話番号": '',
        "会社名": '',
        "部署名": '',
        "役職": '',
        "お問い合わせの内容": '',
        "個人情報の取扱いについて": '',
      },
      rules: {
        "名前1": [
          { required: true, message: '名前が入力されていません', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "名前2": [
          { required: true, message: '名前が入力されていません', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "ふりがな1": [
          { required: true, message: 'ふりがなが入力されていません', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "ふりがな2": [
          { required: true, message: 'ふりがなが入力されていません', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "メールアドレス": [
          { required: true, message: 'メールアドレスが入力されていません', trigger: ['change'] },
          { type: 'email', message: '正しいメールアドレスの書式ではありません', trigger: ['change'] }
        ],
        "電話番号": [
          { required: true, message: '電話番号が入力されていません', trigger: ['change'] },
          { min: 1, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "会社名": [
          { min: 0, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "部署名": [
          { min: 0, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "役職": [
          { min: 0, max: 128, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "お問い合わせの内容": [
          { required: true, message: 'お問い合わせの内容が入力されていません', trigger: ['change'] },
          { min: 1, max: 2800, message: 'Please enter no more than 128 characters.', trigger: ['change'] }
        ],
        "個人情報の取扱いについて": [
          { required: true, message: '個人情報の取扱いについてが選択されていません', trigger: ['change'] },
        ],
      }
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    submitEmailForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loadingInstance = Loading.service({ fullscreen: true });
          // info@roboticsolutions.co.jp
          $.ajax({
            url: 'https://formspree.io/f/xzbllbyz',
            type: 'post',
            async: true,
            data: {
              "名前": this.connectForm['名前1'] + this.connectForm['名前2'],
              "ふりがな": this.connectForm['ふりがな1'] + this.connectForm['ふりがな2'],
              "メールアドレス": this.connectForm['メールアドレス'],
              "電話番号": this.connectForm['電話番号'],
              "会社名": this.connectForm['会社名'],
              "部署名": this.connectForm['部署名'],
              "役職": this.connectForm['役職'],
              "お問い合わせの内容": this.connectForm['お問い合わせの内容'],
              "個人情報の取扱いについて": this.connectForm['個人情報の取扱いについて'],
            },
            dataType: 'json',
            success: (response) => {
              loadingInstance.close()
              this.connectForm['名前1'] = ""
              this.connectForm['名前2'] = ""
              this.connectForm['ふりがな1'] = ""
              this.connectForm['ふりがな2'] = ""
              setTimeout(() => {
                this.$refs[formName].resetFields();
              }, 500)
              this.$alert('<div class="text-center">送信完了</div>', 'Message', {
                closeOnClickModal: true,
                confirmButtonText: 'はい',
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
              });
            },
            error: (res) => {
              loadingInstance.close()
              this.$alert('<div class="text-center">送信失敗しました</div>', 'Message', {
                closeOnClickModal: true,
                confirmButtonText: 'はい',
                dangerouslyUseHTMLString: true,
                callback: action => {
                }
              });
            }
          })
        } else {
          let mql = window.matchMedia('(max-width:768px)')
          if (mql.matches) {
            $(document.documentElement).animate({
              scrollTop: 500
            }, 600)
          } else {
            $(document.documentElement).animate({
              scrollTop: 700
            }, 600)
          }
          return false
        }
      })

    },
    init() {

      $(".series-PageTitle_Inner").eq(0).addClass('appear')
      $('.contact-index-appear-1').addClass('st-Grid_Inner_appear')
      $('.contact-index-appear-2').addClass('appear')
      $('.contact-index-appear-3').addClass('appear')

      // element.offsetHeight
      $(document).scroll(() => {

        if (this.$route.path != '/contact/index') {
          return false
        }

        let scroH = $(document).scrollTop()
        let viewW = $(window).width()

        if (scroH > 50) {
          $('.st-Header').addClass('is-follow')
          $('.st-Footer_Pagetop').addClass('is-follow')
        } else {
          $('.st-Header').removeClass('is-follow')
          $('.st-Footer_Pagetop').removeClass('is-follow')
        }

        if (viewW > 769) {
          if (scroH > 300) {
            $('.series-PageTitle_Inner').eq(0).removeClass('appear')
          } else {
            $('.series-PageTitle_Inner').eq(0).addClass('appear')
          }

          if (scroH > 700) {
            $('.contact-index-appear-1').removeClass('st-Grid_Inner_appear')
            $('.contact-index-appear-2').removeClass('appear')
          } else {
            $('.contact-index-appear-1').addClass('st-Grid_Inner_appear')
            $('.contact-index-appear-2').addClass('appear')
          }

          if (scroH > 780) {
            $('.contact-index-appear-4').addClass('appear')
          } else {
            $('.contact-index-appear-4').removeClass('appear')
          }
        } else {
          $('.series-PageTitle_Inner').eq(0).addClass('appear')
          $('.contact-index-appear-1').addClass('st-Grid_Inner_appear')
          $('.contact-index-appear-2').addClass('appear')
          $('.contact-index-appear-4').addClass('appear')
        }
      })
    }
  }
}
</script>
<style scoped src="../../../../static/css/contact.css">
</style>



// WEBPACK FOOTER //
// src/components/pages/contact/contact-us.vue